import slugify from 'slugify';

/**
 * Generate a URL-friendly slug from a title
 * @param {string} title - Blog title
 * @returns {string} URL slug
 */
export const generateSlug = (title) => {
  return slugify(title, {
    lower: true,
    strict: true,
    remove: /[*+~.()'"!:@]/g
  });
};

/**
 * Calculate reading time based on content
 * @param {string} content - Blog content (HTML or plain text)
 * @returns {string} Reading time (e.g., "5 min read")
 */
export const calculateReadTime = (content) => {
  // Strip HTML tags and count words
  const text = content.replace(/<[^>]*>/g, '');
  const words = text.trim().split(/\s+/).length;
  const readTime = Math.ceil(words / 200); // Average reading speed: 200 words/min
  return `${readTime} min read`;
};

/**
 * Format blog data before saving
 * @param {Object} data - Raw blog data
 * @returns {Object} Formatted blog data
 */
export const formatBlogData = (data) => {
  const slug = data.slug || generateSlug(data.title);
  const readTime = calculateReadTime(data.content || '');
  
  return {
    ...data,
    slug,
    readTime,
    published: data.published || false,
    featured: data.featured || false,
    tags: data.tags || [],
    date: data.date || new Date().toISOString().split('T')[0]
  };
};